import { render, staticRenderFns } from "./settingsCities.vue?vue&type=template&id=b68157fe&scoped=true&"
import script from "./settingsCities.vue?vue&type=script&lang=js&"
export * from "./settingsCities.vue?vue&type=script&lang=js&"
import style0 from "./settingsCities.vue?vue&type=style&index=0&id=b68157fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68157fe",
  null
  
)

export default component.exports